"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGoogleMapsSearchUrl = void 0;
/**
 * Creates a Google Maps search URL
 * @param addressQuery A string query for an address or partial address.
 * @returns URL to search google maps for the address
 */
const createGoogleMapsSearchUrl = (addressQuery) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressQuery !== null && addressQuery !== void 0 ? addressQuery : '')}`;
exports.createGoogleMapsSearchUrl = createGoogleMapsSearchUrl;
//# sourceMappingURL=create-google-maps-search-url.js.map